import { FC, Suspense } from 'react';

import { Heading } from '@savgroup-front-common/core/atoms/Heading';
import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import { BaseLoader } from '@savgroup-front-common/core/molecules/BaseLoader';
import { MyAccountIcon } from '@savgroup-front-common/core/protons/IconsNewDesign/MyAccount.icon';
import { Invoice } from '@savgroup-front-common/types';
import { ICONS_TYPE } from '@savgroup-front-common/types/Icon';

import { Payment } from '../../../../../../components/Payments/Payment';

import { FileFollowupsCashRegisterPayment } from './FileFollowupsCashRegisterPayment/FileFollowupsCashRegisterPayment';
import { usePaymentCard } from './hooks/usePaymentCard';
import messages from './messages';
import { $HeadingIcon } from './PaymentCard.styles';
import QuotationSummary from './QuotationSummary/QuotationSummary';

interface PaymentCardProps {
  invoice?: Invoice;
  sellerId: string;
  claimGroupId: string;
  fileId: string;
  onSubmitSuccess: () => Promise<void>;
  isFormCompleted?: boolean;
}

export const PaymentCard: FC<PaymentCardProps> = ({
  invoice,
  sellerId,
  claimGroupId,
  fileId,
  onSubmitSuccess,
  isFormCompleted = true,
}) => {
  const { paymentUrl } = usePaymentCard({ sellerId });

  if (!invoice) {
    return null;
  }

  return (
    <Suspense fallback={<BaseLoader />}>
      <QuotationSummary fileId={fileId} />
      <Heading level={3}>
        <$HeadingIcon>
          <MyAccountIcon icon={ICONS_TYPE.CART_ICON} />
        </$HeadingIcon>
        <SafeFormattedMessageWithoutSpread message={messages.paymentTitle} />
      </Heading>
      {paymentUrl && (
        <FileFollowupsCashRegisterPayment
          fileId={fileId}
          invoice={{
            priceWithTax: invoice.priceWithTax,
            currencyTrigram: invoice.currencyTrigram,
          }}
          paymentUrl={paymentUrl}
          claimGroupId={claimGroupId}
          isFormCompleted={isFormCompleted}
        />
      )}

      {!paymentUrl && (
        <Payment
          invoice={{
            id: invoice.id,
            priceWithTax: invoice.priceWithTax,
            currencyTrigram: invoice.currency,
          }}
          onSubmitSuccess={onSubmitSuccess}
          isFormCompleted={isFormCompleted}
          claimGroupId={claimGroupId}
          fileId={fileId}
        />
      )}
    </Suspense>
  );
};
